import React from 'react';
import PioneerBadge from './PioneerBadge';
import AchillesBadge from './AchillesBadge';

const UserCard = ({ user, isFollowing, onToggleFollow, onViewProfile, tags, currentUserId, charityName, fundraisingUrl }) => {
  const displayName = user.first_name
    ? `${user.first_name} ${user.last_name || ''}`.trim()
    : user.name || 'Runner';

  const initials = user.first_name
    ? (user.first_name[0] + (user.last_name?.[0] || '')).toUpperCase()
    : (user.name || 'R').substring(0, 2).toUpperCase();

  const isSelf = currentUserId === user.id;

  return (
    <div
      onClick={() => onViewProfile && onViewProfile(user.id)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '0.75rem 1rem',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 138, 61, 0.15)',
        borderRadius: '12px',
        cursor: onViewProfile ? 'pointer' : 'default',
        transition: 'border-color 0.2s ease',
      }}
      onMouseEnter={(e) => { if (onViewProfile) e.currentTarget.style.borderColor = 'rgba(255, 138, 61, 0.4)'; }}
      onMouseLeave={(e) => { if (onViewProfile) e.currentTarget.style.borderColor = 'rgba(255, 138, 61, 0.15)'; }}
    >
      {/* Avatar */}
      <div style={{
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: user.profile_photo ? 'transparent' : 'rgba(255, 138, 61, 0.2)',
        color: '#FF8A3D',
        fontWeight: 700,
        fontSize: '0.9rem',
      }}>
        {user.profile_photo ? (
          <img src={user.profile_photo} alt={`${displayName} avatar`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span aria-label={`${displayName} avatar`}>{initials}</span>
        )}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
          <span style={{ color: '#FFFFFF', fontWeight: 600, fontSize: '0.95rem' }}>
            {displayName}
          </span>
          {user.verified_athlete && (
            <span style={{
              color: '#4ade80',
              fontSize: '0.7rem',
              fontWeight: 600,
              background: 'rgba(74, 222, 128, 0.15)',
              padding: '0.1rem 0.4rem',
              borderRadius: '8px',
            }}>
              ✓
            </span>
          )}
          <PioneerBadge isPioneer={user.is_pioneer} pioneerNumber={user.pioneer_number} isCommunityBuilder={user.is_community_builder} size="small" />
        </div>
        {charityName && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', marginTop: '0.25rem' }}>
            <span style={{
              fontSize: '0.7rem',
              color: '#f472b6',
              background: 'rgba(244, 114, 182, 0.12)',
              padding: '0.1rem 0.5rem',
              borderRadius: '10px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem'
            }}>
              {'\u2764\uFE0F'} {charityName}
            </span>
            {fundraisingUrl && (
              <a
                href={fundraisingUrl.startsWith('http') ? fundraisingUrl : `https://${fundraisingUrl}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: '0.7rem',
                  color: '#FF8A3D',
                  textDecoration: 'none',
                  fontWeight: 500
                }}
              >
                Donate {'\u2197'}
              </a>
            )}
          </div>
        )}
        {tags && tags.length > 0 && (
          <div style={{ display: 'flex', gap: '0.3rem', marginTop: '0.3rem', flexWrap: 'wrap' }}>
            {tags.slice(0, 3).map(tag => (
              tag === 'achilles-guide' || tag === 'achilles-athlete' ? (
                <AchillesBadge key={tag} type={tag === 'achilles-guide' ? 'guide' : 'athlete'} compact />
              ) : (
                <span key={tag} style={{
                  fontSize: '0.7rem',
                  color: '#FF8A3D',
                  background: 'rgba(255, 138, 61, 0.12)',
                  padding: '0.1rem 0.5rem',
                  borderRadius: '10px',
                  fontWeight: 500,
                }}>
                  {tag}
                </span>
              )
            ))}
          </div>
        )}
      </div>

      {/* Follow button */}
      {!isSelf && onToggleFollow && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleFollow(user.id);
          }}
          aria-label={isFollowing ? `Unfollow ${displayName}` : `Follow ${displayName}`}
          aria-pressed={isFollowing}
          style={{
            padding: '0.4rem 1rem',
            background: isFollowing ? '#FF8A3D' : 'transparent',
            border: isFollowing ? 'none' : '1px solid #FF8A3D',
            color: isFollowing ? '#0B0B10' : '#FF8A3D',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '0.8rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            transition: 'all 0.2s ease',
          }}
        >
          {isFollowing ? 'Following' : 'Follow'}
        </button>
      )}
    </div>
  );
};

export default UserCard;
